export default "__VITE_ASSET__BC6Fp6ls__"